export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7930.c1fd0f8b.jpg";